export const SET_OPTION_VALIDITY = 'SET_OPTION_VALIDITY';
export const UNSET_OPTION_VALIDITY = 'UNSET_OPTION_VALIDITY';
type State = Array<any> | null | undefined;
const initialState: State = null;
export const optionValidityReducer = (state: State = initialState, action: any = {}) => {
  switch (action.type) {
    case SET_OPTION_VALIDITY:
      /**
       * TODO: fix async tests with payload missing
       * broke:
       * - src/client/components/widgets/price-remote/PriceRemote.spec.js
       * - src/client/views/booking/booking-confirmation/BookingConfirmationView.spec.js
       */
      return action?.payload?.locale.optionValidity ?? null;

    case UNSET_OPTION_VALIDITY:
      return initialState;

    default:
      return state;
  }
};
